import { Radio } from 'antd';
import styled, { css } from 'styled-components';

import SvgIcon from '~src/shared/SvgIcon';
import { media } from '~src/styles/media-templates';

import { TextAlign } from './InputLabelWrapper';
import TextareaAutosize from "react-textarea-autosize";

export const InputImg = styled(SvgIcon)<{ $valid: boolean }>`
  color: ${({ $valid, theme }) => ($valid ? theme.baseBlue.a10 : theme.red.a10)};
  opacity: 0.5;
  position: absolute;
  top: 1.2rem;
  left: 1rem;
`;

export const Input = styled.input<{ $valid: boolean; readonly?: boolean; $textAlign?: 'left' | 'right' }>(
  ({ theme, $valid }) => css`
    height: ${theme.sz.inputHeight};
    padding: 2.0333rem 0.6rem 0.5333rem 3.5rem;
    margin: 0 10px 15px 0;
    width: 100%;
    color: ${$valid ? theme.baseBlue.a10 : theme.red.a10};
    border-radius: 5px;
    border: solid 1px ${$valid ? theme.white.a10 : theme.red.a10};
    background-color: ${$valid ? theme.white.a10 : theme.red.a1};
    box-shadow: 0 0 14px 0 rgba(78, 84, 107, 0.05);
    transition: all 0.2s ease-in;
    font-weight: 400;
    font-size: 15px;
    &:focus {
      box-shadow: 0 18px 30px -11px ${$valid ? 'rgba(78, 84, 107, 0.2)' : 'rgba(255, 76, 121, 0.2)'};
      border: solid 1px ${$valid ? theme.baseBlue.a10 : theme.red.a10};
      outline: none;
      ~ ${InputImg} {
        opacity: 1;
      }
    }
    ~ ${InputImg} {
      opacity: 0.5;
      position: absolute;
      top: 1.2rem;
      left: 1rem;
    }
    ~ label {
      color: ${$valid ? '' : theme.red.a10};
    }
  `,
);

export const Text = styled.textarea<{ $valid: boolean; $autoExpand?: boolean }>(
  ({ theme, $valid, $autoExpand }) => css`
    width: 100%;
    padding: 3rem 0.6rem 1.333rem 3.5rem;
    border-radius: 5px;
    min-height: 180px;
    box-shadow: 0 4px 14px 0 rgba(0, 0, 0, 0.03);
    color: ${$valid ? theme.black.a6 : theme.red.a10};
    border: solid 1px ${$valid ? theme.white.a10 : theme.red.a10};
    background-color: ${$valid ? theme.white.a10 : theme.red.a1};
    resize: ${$autoExpand ? 'none' : 'vertical'};
    &:focus {
      box-shadow: 0 18px 30px -11px ${$valid ? 'rgba(78, 84, 107, 0.2)' : 'rgba(255, 76, 121, 0.2)'};
      border: solid 1px ${$valid ? theme.baseBlue.a10 : theme.red.a10};
      outline: none;
      ~ ${InputImg} {
        opacity: 1;
      }
    }
    ~ ${InputImg} {
      opacity: 0.5;
      position: absolute;
      top: 1.2rem;
      left: 1rem;
    }

    &::placeholder {
      color: ${$valid ? theme.baseBlue.a10 : theme.red.a10};
    }

    ~ label {
      color: ${$valid ? '' : theme.red.a10};
    }
  `,
);

export const RadioBtn = styled(Radio.Button)`
  height: ${({ theme }) => theme.sz.inputHeight};
  width: 100%;
`;

export const DatePickerContainerWrapper = styled.div<{ $valid: boolean }>(
  ({ theme, $valid }) => css`
    border: none;
    width: 153px;

    .ant-picker {
      background: unset;
      border: none;
      padding: 0;
      &:focus {
        outline: none;
        border: none;
      }
    }

    .ant-picker-focused {
      box-shadow: none;
      &:focus {
        outline: none;
      }
    }

    .ant-picker-input {
      height: ${theme.sz.inputHeight};
      font-size: 0.8666rem;
      width: 100%;
      cursor: pointer;
      display: flex;
      color: ${$valid ? theme.baseBlue.a10 : theme.red.a10};
      border-radius: 5px;
      border: solid 1px ${$valid ? theme.black.a1 : theme.red.a10};
      background-color: ${$valid ? theme.white.a10 : theme.red.a1};
      transition: all 0.2s ease-in;
      padding: 2.1rem 2rem 0.3333rem 1rem;
      box-shadow: none;
      &:focus {
        outline: none;
        box-shadow: 0 18px 30px -11px ${$valid ? 'rgba(78, 84, 107, 0.2)' : 'rgba(255, 76, 121, 0.2)'};
        border: solid 1px ${$valid ? theme.baseBlue.a10 : theme.red.a10};
        ~ ${InputImg} {
          opacity: 1;
        }
      }

      ~ label {
        color: ${$valid ? '' : theme.red.a10};
      }

      .ant-picker-suffix {
        position: absolute;
        top: 40%;
        right: 8px;
        color: rgba(0, 0, 0, 0.25);
      }

      .ant-picker-clear {
        right: 8px;
      }
    }
  `,
);
/* stylelint-disable no-descending-specificity */
export const InputWithLabel = styled.div<{
  $hasValue: boolean;
  $insideForm?: boolean;
  $valid?: boolean;
  $isTextArea?: boolean;
  $textAlign?: TextAlign;
}>(
  ({ theme, $valid, $hasValue, $insideForm, $isTextArea, $textAlign }) => css`
    position: relative;
    width: 100%;
    label {
      font-size: ${$hasValue ? '0.7' : '0.8'}rem;
      position: absolute;
      color: ${$valid ? 'rgba(78, 84, 107, 0.7)' : 'rgb(255,76,121)'};
      top: 1px;
      padding-top: ${$hasValue ? '0.6' : '1.25'}rem;
      left: ${$insideForm ? '1' : '3.5'}rem;
      transition: 0.2s ease all;
      text-transform: uppercase;
      pointer-events: none;
      z-index: 2;
      background-color: ${$isTextArea ? (!$valid ? 'rgb(251,242,244)' : theme.white.a10) : 'none'};
      right: ${($textAlign === 'right' && '0.6rem') || 'auto'};
    }
    input {
      font-size: 0.867rem;
    }
    input,
    textarea {
      label {
        padding-top: 1.35rem;
        font-size: 0.8rem;
      }
    }
    input:focus,
    textarea:focus {
      label {
        padding-top: 0.6rem;
        font-size: 0.7rem;
      }
    }

    ${media.phone`
      input {
        font-size: 0.9375rem;
      }
    `}
  `,
);
/* stylelint-enable */

export const LabelBlank = styled.div<{ $valid: boolean }>`
  margin: 1px 2px 0 0;
  background-color: ${({ $valid, theme }) => ($valid ? theme.white.a10 : theme.red.a1)};
  position: absolute;
  color: ${({ theme }) => theme.baseBlue.a10};
  top: 0;
  height: 36px;
  border-top-right-radius: 5px;
  left: 3.5rem;
  width: calc(100% - 4.6rem);
  transition: 0.2s ease all;
  text-transform: uppercase;
  pointer-events: none;
  z-index: 1;
`;

export const ErrorMessage = styled.span`
  margin-left: 1rem;
  color: ${({ theme }) => theme.red.a10};
  font-style: italic;
  font-weight: 300;
  font-size: 0.8rem;
  display: block;
  min-height: 0.5rem;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  &.visible {
    opacity: 1;
  }
`;

export const FormInput = styled(Input)`
  padding: 2.1rem 0.6rem 0.3333rem 1rem;
  border: ${({ readonly, $valid, theme }) =>
    readonly ? 'none' : `solid 1px ${$valid ? theme.black.a1 : theme.red.a10}`};
  box-shadow: none;
  text-align: ${({ $textAlign }) => $textAlign || 'left'};
  opacity: ${({readonly}) => readonly ? 0.4 : 1};
  &:focus {
    box-shadow: none;
    border: solid 1px ${({ theme }) => theme.baseBlue.a10};
    outline: none;
  }
  &::placeholder {
    opacity: 0.5;
  }
`;

export const StyledTextAreaAutosize = styled(TextareaAutosize)<{ $valid: boolean; $minHeight: number; $autoExpand?: boolean }>`
  padding: 2.1rem 0.6rem 0.3333rem 1rem;
  width: 100%;
  border-radius: 5px;
  border-style: solid;
  border-width: 1px;
  border-color: ${({ $valid, theme }) => ($valid ? theme.black.a1 : theme.red.a10)};
  box-shadow: none;
  min-height: ${({ $minHeight }) => $minHeight}px;

  &:focus {
    box-shadow: none;
    border-color: ${({ $valid, theme }) => ($valid ? theme.baseBlue.a10 : theme.red.a10)};
    outline: none;
  }`
